<template>
    <div>
        <span class="fi-input-wrapper">
            <input class="caption" type="text" v-model="innerItem.caption" @focus="$emit('focused', innerItem, 'caption')" />
            <em class="fa fi-multilangs"
                @mouseup="onMultiLangs" />
        </span><!--
        --><select ref="type" class="type" :value="innerItem.type" @change="typeChanged($event.target)" @focus="$emit('focused', innerItem, 'type')">
            <template v-for="(item, idx) in source">
                <option :key="idx" :value="item">{{ item }}</option>
            </template>
        </select><!--
        --><input :class="['expr', itemReadonly && 'readonly']" type="text" :value="innerItem.expression" :readOnly.prop="itemReadonly" @focus="$emit('focused', innerItem, 'expression')" @input="valueChanged($event.target)" />
    </div>
</template>

<style scoped>
    div {
        height: 24px;
        border-bottom: 1px solid #a0a0a0;
    }
    .fi-input-wrapper {
        width: 30%;
        position: relative;
        display: inline-block;
    }
    .caption {
        height: 24px;
        /* padding-right: 24px; */
        box-sizing: border-box;
    }
    .fi-multilangs {
        position: absolute;
        height: 14px;
        top: 50%;
        right: 4px;
        margin-top: -8px;
        font-size: 14px;
        font-weight: 300;
        cursor: pointer;
    }
    .fi-multilangs::before {
        content: '\f022';
    }
    .type {
        width: 30%;
        /*margin-left: -1px;*/
        border-left: 1px solid #a0a0a0;
        border-right: 1px solid #a0a0a0;
    }
    .expr { width: 40%; }
    input {
        text-indent: 2px;
    }
    input, select {
        border: none;
        height: 100%;
        padding: 0;
        margin: 0;
        vertical-align: top;
        outline: none;
    }
    input.readonly {
        background: lightgray;
    }
</style>

<script>
module.exports = {
    props: {
        field: String,
        item: Object,
        source: Array,
    },
    data() {
        return {
            itemReadonly: true,
        };
    },
    computed: {
        innerItem() {
            return this.item || {};
        },
    },
    mounted() {
        this.typeChanged(this.$refs.type, true);
    },
    methods: {
        typeChanged(target, firstload) {
            this.innerItem.type = target.value;
            this.itemReadonly = !/^expression$/i.test(target.value);
            if (this.itemReadonly) {
                if (this.innerItem.type == null || /^\s*$/.test(this.innerItem.type)) {
                    this.innerItem.expression = '';
                } else {
                    const items = Array.prototype.filter.call(target.children, item => item.selected);
                    if (items.length > 0) {
                        this.innerItem.expression = `${items[0].innerText}()`;
                    }
                }
            } else if (!firstload || this.innerItem.expression == null || this.innerItem.expression.length === 0) {
                this.innerItem.expression = `Count([${this.field}])`;
            }
        },
        valueChanged(target) {
            this.innerItem.expression = target.value;
        },
        onMultiLangs() {
            if (typeof this.innerItem.onMultiLangs === 'function') {
                this.innerItem.onMultiLangs();
            }
        },
    },
};
</script>



// WEBPACK FOOTER //
// aggregateItem.vue?3e934579